// extracted by mini-css-extract-plugin
export default {"container":"Intro_container__ngq+S","leftContainer":"Intro_leftContainer__BlvyB","rightContainer":"Intro_rightContainer__Shkq0"};